import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router-dom";
import "./styles/style.css";
import { ATSTheme } from "./utils/HRMSTheme";
import ATSRoutes from "./utils/routes";
import HRMSNavigationRoutes from "./utils/navigationRoutes";
import HRMSMainLayout from "./layouts/HRMSMainLayout";

const HRMSApp = () => {
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        ...ATSTheme,
      }}
      componentSize="large"
    >
      <Routes>
        <Route element={<HRMSMainLayout />}>
          {Object.values(ATSRoutes).map(({ path, component: Page }) => (
            <Route key={path} path={path} element={<Page />} />
          ))}
          <Route
            path="*"
            element={
              <NotFoundPage
                buttonLink={"/hrms/" + HRMSNavigationRoutes.EMP_LIST}
              />
            }
          />
        </Route>
      </Routes>
    </ConfigProvider>
  );
};

export default HRMSApp;
